export const buildProvenance = { "commitHash": "29694d9cc2a6de5c4cc8b44aaeea83f9100c4c6e", "branchName": "refs/heads/release/2024.4", "buildDate": "2024-11-26T23:42:58.582Z", "version": "2024.4.6948" };
